export default __webpack_public_path__ + "static/media/aquarium-logo.d17a3a3a.jpg";